exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-edit-batch-processing-component .upload{width:100%}.modal-edit-batch-processing-component .upload .upload-draggable{width:100%}.modal-edit-batch-processing-component .help p.success{color:#48c78e}.modal-edit-batch-processing-component .help p.danger{color:#f14668}.modal-edit-batch-processing-component .help p .icon{margin-left:8px;width:auto}.modal-edit-batch-processing-component .help p .icon .mdi:before{font-size:12px}.modal-edit-batch-processing-component .content-btns{margin-top:2rem;text-align:right}", ""]);

// exports
